import { useState } from 'react';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import type { PluginConfigComponentProps } from '../types';
import type { SacolinhasConfig } from './types';

export const SacolinhasConfigComponent = ({ config, onSave, isSaving }: PluginConfigComponentProps<SacolinhasConfig>) => {
  const [draft, setDraft] = useState(config);
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Label>Usar prazo máximo para sacolinhas</Label>
        <Switch checked={draft.deadline_enabled} onCheckedChange={(v) => setDraft({ ...draft, deadline_enabled: v })} />
      </div>
      {draft.deadline_enabled && (
        <div>
          <Label>Dias a partir da primeira compra</Label>
          <Input
            type="number" min={1} max={365}
            value={draft.deadline_days}
            onChange={(e) => setDraft({ ...draft, deadline_days: parseInt(e.target.value, 10) || 0 })}
          />
          <p className="text-xs text-muted-foreground mt-1">
            Sacolinhas existentes não são afetadas. Novas sacolinhas usarão o prazo configurado.
          </p>
        </div>
      )}
      <Button onClick={() => onSave(draft)} disabled={isSaving}>
        {isSaving ? 'Salvando...' : 'Salvar'}
      </Button>
    </div>
  );
};
